// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1chXR","head":"ProcedureTableInfo_head__2oC2K"};